import { IEvent } from "@Interfaces";
import { EVENT_ENUM } from "@Utils";

export const getEventHeaderTitle = ({
    eventData,
}: {
    eventData: IEvent.IEventData;
}) =>
    `${
        eventData?.metadata?.event?.type_name ||
        EVENT_ENUM[eventData.type]?.SHORT_TITLE ||
        "Class"
    }`;
